// Default page permissions - can be overridden by admins (now stored in database)
export const DEFAULT_PAGE_PERMISSIONS = {
  '/': ['none', 'stocktake_champion', 'stocktake_controller', 'stocktake_auditor', 'supervisor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/readiness': ['stocktake_champion', 'stocktake_controller', 'stocktake_auditor', 'supervisor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/scheduling': ['stocktake_controller', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/pre-stocktake': ['stocktake_champion', 'stocktake_controller', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/roster-areas': ['stocktake_controller', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/device-pool': ['stocktake_champion', 'stocktake_controller', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/checklist': ['stocktake_champion', 'stocktake_controller', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/store-map': ['stocktake_champion', 'stocktake_controller', 'supervisor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/attendance': ['stocktake_champion', 'stocktake_controller', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/miscounts': ['stocktake_auditor', 'supervisor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/verifications': ['stocktake_auditor', 'supervisor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/admin-cutoff': ['stocktake_auditor', 'supervisor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/top-stock': ['stocktake_champion', 'stocktake_controller', 'stocktake_auditor', 'store_manager', 'complex_manager', 'regional_manager', 'network_admin'],
  '/settings': ['store_manager', 'complex_manager', 'regional_manager', 'network_admin']
};

// In-memory cache for permissions (refreshed on login/page load)
let cachedPermissions = null;

// Load page permissions from the database
export const loadPagePermissionsFromDB = async (token) => {
  try {
    const API = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${API}/api/page-permissions`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (response.ok) {
      const data = await response.json();
      if (data && typeof data === 'object') {
        cachedPermissions = data;
        return data;
      }
    }
  } catch (e) {
    console.error('Failed to load page permissions from database:', e);
  }
  return DEFAULT_PAGE_PERMISSIONS;
};

// Get current permissions (uses cache or defaults)
export const loadPagePermissions = () => {
  if (cachedPermissions) {
    return cachedPermissions;
  }
  return DEFAULT_PAGE_PERMISSIONS;
};

// Save custom permissions to database (Network Admin only)
export const savePagePermissions = async (permissions, token) => {
  try {
    const API = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${API}/api/page-permissions`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}` 
      },
      body: JSON.stringify({ permissions })
    });
    
    if (response.ok) {
      cachedPermissions = permissions;
      return true;
    }
    return false;
  } catch (e) {
    console.error('Failed to save permissions:', e);
    return false;
  }
};

// Reset to defaults (delete from database)
export const resetPagePermissions = async (token) => {
  try {
    const API = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${API}/api/page-permissions`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (response.ok) {
      cachedPermissions = null;
      return true;
    }
    return false;
  } catch (e) {
    console.error('Failed to reset permissions:', e);
    return false;
  }
};

// Update the cache
export const updatePermissionsCache = (permissions) => {
  cachedPermissions = permissions;
};

// Clear the cache (on logout)
export const clearPermissionsCache = () => {
  cachedPermissions = null;
};

export const PAGE_PERMISSIONS = DEFAULT_PAGE_PERMISSIONS;
